export const isShadow =
  process.env.REACT_APP_ENVIRONMENT === "shadow";

export const isDevelopment =
  process.env.REACT_APP_ENVIRONMENT !== "production" && !isShadow;
